module.exports = __webpack_public_path__ + "static/img/allège.0d4f67f.png";


//////////////////
// WEBPACK FOOTER
// ./src-detail/img/allège.png
// module id = mI59
// module chunks = 1